/**
 * RH§1 — payable year vs tax year.
 *
 * A tax bill carries TWO years, frequently different:
 *   • tax_year     — the year of the value being taxed (e.g. 2025)
 *   • payable year — the year the bill is actually due + paid (e.g. 2026). This is
 *     stored on `tax_bills.process_year` (Siger calls the field "Process") and
 *     defaults from the collector's payable year for that tax year.
 *
 * The bill lives in the client's PAYABLE year but is LABELED with its tax year, so
 * the distinction is never ambiguous on a list or header: render "2025 (payable
 * 2026)". When the two match (or payable is missing) it collapses to just the tax
 * year, so a normal single-year bill reads plainly.
 */
export function billYearLabel(
  taxYear: number | null | undefined,
  payableYear: number | null | undefined,
): string {
  if (taxYear == null) return payableYear != null ? `payable ${payableYear}` : '—';
  if (payableYear == null || payableYear === taxYear) return String(taxYear);
  return `${taxYear} (payable ${payableYear})`;
}
